import React from 'react';
import { Input, Button, Space, Typography, Divider, Checkbox } from 'antd';
import { dateFromString } from '../../../../utils/dateFromString';

const { TextArea } = Input;
const { Text } = Typography;

export default function Historial({
  historial,
  nuevoComentario,
  setNuevoComentario,
  notificarRedProveedores,
  setNotificarRedProveedores,
  onAgregarHistorial,
  loadingHistorial
}) {
  return (
    <div style={{ fontSize: '11px', display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Space direction="vertical" size={6} style={{ width: '100%', marginBottom: 10 }}>
        <TextArea
          placeholder="Agregar comentario..."
          value={nuevoComentario}
          onChange={(e) => setNuevoComentario(e.target.value)}
          rows={2}
          size="small"
          style={{ fontSize: '11px' }}
        />

        <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
          <Button
            type="default"
            size="small"
            onClick={onAgregarHistorial}
            className="btn-rounded"
            style={{ fontSize: '11px', height: '24px', flex: 1 }}
            loading={loadingHistorial}
            disabled={loadingHistorial}
          >
            Agregar
          </Button>
          <Checkbox
            checked={notificarRedProveedores}
            onChange={(e) => setNotificarRedProveedores(e.target.checked)}
            style={{ fontSize: '10px', whiteSpace: 'nowrap' }}
          >
            Notificar Proveedores
          </Checkbox>
        </div>
      </Space>

      <div style={{ flex: 1, overflowY: 'auto', minHeight: 0, maxHeight: 300 }}>
        <Space direction="vertical" size={0} style={{ width: '100%' }}>
          {historial?.slice().reverse().map((item, index) => (
            <div key={item.ordenPagoHistorialID || index}>
              <div style={{ paddingBottom: 6, lineHeight: 1.4 }}>
                <Text type="secondary" style={{ fontSize: '10px', display: 'block', marginBottom: 2 }}>
                  {dateFromString(item.fecha)?.f1 || item.fecha} | {item.nombre || item.nombreUsuario || item.usuario}
                </Text>
                <Text style={{ fontSize: '11px', display: 'block' }}>
                  {item.comentario || item.accion}
                </Text>
              </div>
              {index !== historial.length - 1 && <Divider style={{ margin: '6px 0' }} />}
            </div>
          ))}
        </Space>
      </div>
    </div>
  );
}